// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialog__title[data-v-71c0433e]{font-size:1rem;word-break:normal}", ""]);
// Exports
module.exports = exports;
